import React, { PropsWithChildren, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { DialogContentContainer } from '../../../../pcr-selector/styled';
import CompilerPcrSelectorDialogForm from './CompilerPcrSelectorDialogForm';
import { PCRModel } from 'services/EpdClient';
import { ProcessStatus } from 'constants/constants';
import { Option } from 'types/types';
import { PrimaryButton, SecondaryButton } from 'components/v2/buttons';
import { HelpBox } from 'components/v2/help-boxes';
import { usePcrSelectorDialogDeprecatedPcrDisclaimerText } from './usePcrSelectorDialogDeprecatedPcrDisclaimerText';

type TProps = PropsWithChildren<{
  visible: boolean;
  onHide(): void;
  initialPcr: PCRModel | undefined;
  onPcrChange(pcr: PCRModel): void;
  productCategoryList: Option[];
  productCategory: Option | undefined;
  pcrList: PCRModel[];
  status: ProcessStatus;
  onProductCategorySelect: (value: Option | undefined) => void;
  disableCategorySelector: boolean;
}>;

const CompilerPcrSelectorDialog = ({
  visible,
  onHide,
  initialPcr,
  onPcrChange,
  productCategoryList,
  productCategory,
  pcrList,
  status,
  onProductCategorySelect,
  disableCategorySelector,
}: TProps) => {
  const formRef = useRef<React.ElementRef<typeof CompilerPcrSelectorDialogForm>>(null);
  const pcrDisclaimerText = usePcrSelectorDialogDeprecatedPcrDisclaimerText();

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Add Product Category Rule (PCR)"
      contentStyle={pcrList?.length > 0 ? {} : { overflowY: 'initial' }}
      resizable={false}
      style={{ width: '35rem' }}
      footer={
        <>
          <SecondaryButton label="Cancel" onClick={onHide} outlined />
          <PrimaryButton
            label="Add"
            onClick={() => {
              const pcr = formRef.current?.getSelectedValue();
              onHide();
              if (pcr) {
                onPcrChange(pcr);
              }
            }}
            autoFocus
          />
        </>
      }
    >
      <DialogContentContainer>
        {pcrDisclaimerText && <HelpBox style={{ marginBottom: '22px' }}>{pcrDisclaimerText}</HelpBox>}

        <CompilerPcrSelectorDialogForm
          ref={formRef}
          initialPcr={initialPcr}
          productCategoryList={productCategoryList}
          productCategory={productCategory}
          pcrList={pcrList}
          onProductCategorySelect={onProductCategorySelect}
          status={status}
          disableCategorySelector={disableCategorySelector}
        />
      </DialogContentContainer>
    </Dialog>
  );
};

export default CompilerPcrSelectorDialog;
